import { ListItemText } from '@mui/material';
import clsx from 'clsx';
import React from 'react';

import { defaultListItemStyles, DynamicListItem } from './DynamicListItem';

interface SidebarSectionTitleProps {
  htmlId: string;
  sectionTitle?: string;
}

export const SidebarSectionTitle: React.FC<SidebarSectionTitleProps> = ({
  htmlId,
  sectionTitle,
  children,
}) => (
  <DynamicListItem
    htmlId={htmlId}
    data-testid={htmlId}
    className={clsx('py-2 pb-0', defaultListItemStyles)}
    button={false}
  >
    <ListItemText
      primary={sectionTitle}
      classes={{
        root: 'my-0.5',
        primary: 'text-light-gray text-[12px] leading-[18px]',
      }}
    />
    {children}
  </DynamicListItem>
);
